import React, { useEffect, useState } from "react";
import "./AdminSiteContent.css";
import EditModal from "./ActionModals/EditModal";
// import SearchIcon from "../../../Assets/Images/SearchIcon.png";
// import demoImage from "../../../Assets/Images/demoImageFeature.png";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ColorRing } from "react-loader-spinner";

// import { Button } from "react-bootstrap";
import { GetUserDetails } from "../../../Helpers/Utility";
import { deleteData, postData } from "../../../Services/Api";

export default function AdminSiteContent() {
  const [sitePlans, setSitePlans] = useState([]);

  const plansPerPage = 10; // Number of plans to display per page
  // const [isAdding, setIsAdding] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [recordCount, setRecordCount] = useState(0);
  const [editModalOpen, setEditModalOpen] = useState(false); // State to track if the edit modal is open
  const [selectedPlan, setSelectedPlan] = useState(null); // State to track the plan being edited
  const [userToken, setUserToken] = useState("");
  // const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  const getSitePlans = async (token, page, search) => {
    if (!token) return;

    setUserToken(token);

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const data = {
      search_text: search || "",
      page_number: page,
      limit: plansPerPage,
      sortBy: "created_at",
      sortAscDesc: "asc",
    };

    setLoading(true);
    const getDataResponse = await postData("site-features-list", data, headers);
    setLoading(false);
    const { featureList, currentPage } = getDataResponse?.data?.data || {};

    setSitePlans(featureList || []);
    setCurrentPage(currentPage || 1);
    // setRecordCount(recordCount || 0);
    // setTotalPages(totalPageCount || 1);
  };

  useEffect(() => {
    const userDetails = GetUserDetails();
    if (userDetails?.token) {
      getSitePlans(userDetails.token, currentPage);
    }
  }, [currentPage]);

  // Pagination logic to slice plans array for current page
  const indexOfLastPlan = currentPage * plansPerPage;
  const indexOfFirstPlan = indexOfLastPlan - plansPerPage;
  const currentPlans = sitePlans.slice(indexOfFirstPlan, indexOfLastPlan);

  // Function to handle page navigation
  // const handlePageChange = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  const updatePlanList = async () => {
    const userDetails = GetUserDetails();
    if (userDetails?.token) {
      await getSitePlans(userDetails?.token, currentPage);
    }
  };

  // Function to handle edit click
  const handleEditClick = (plan) => {
    console.log("Edit clicked:", plan);
    setSelectedPlan(plan);
    setEditModalOpen(true);
  };
  // Function to handle add click
  // const handleAddClick = () => {
  //   setIsAdding(true);
  //   setEditModalOpen(true);
  // };

  // Function to close the edit modal
  const handleClose = () => {
    setSelectedPlan(null);
    setEditModalOpen(false);
  };

  const handleDeleteClick = (planId) => {
    const userDetails = GetUserDetails();
    if (!userDetails?.token) {
      return;
    }

    const headers = {
      Authorization: `Bearer ${userDetails.token}`,
    };

    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure to delete this site content?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              const sendData = {
                id: planId,
                is_deleted: 1,
              };

              const getDataResponse = await deleteData(
                "delete-site-features",
                sendData,
                headers
              );

              if (getDataResponse.success) {
                setSitePlans((prevPlans) =>
                  prevPlans.filter((plan) => plan.id !== planId)
                );
                // toast.success("Site content deleted successfully");
              } else {
                console.error(
                  "Failed to delete site content:",
                  getDataResponse.message
                );
                toast.error("Failed to delete site content");
              }
            } catch (error) {
              console.error("Error deleting site content:", error);
              toast.error("An error occurred while deleting the site content");
            }
          },
        },
        {
          label: "No",
          onClick: () => console.log("Delete cancelled"),
        },
      ],
    });
  };

  return (
    <section className="AdminSubscription px-3">
      <div className="AdminSubscriptionTable">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-block w-100 headingAdmin py-3">
            <h2 className="">Features listing</h2>
          </div>
          {/* <div className="input-group justify-content-end">
            <span className="input-group-text border-end-0 rounded-start-5 bg-white">
              <img src={SearchIcon} alt="Avatar" className="img-fluid" />
            </span>
            <input
              type="text"
              className="form-control searchTextBox rounded-end-5 border-start-0"
              style={{ maxWidth: "300px" }}
              placeholder="Search Here..."
            />
          </div>
          <Button
            onClick={handleAddClick}
            className="addBTN d-block respoNavBtn btn btn-default startedBtn rounded-5 pt-1 pb-1 px-4 ms-2"
          >
            <div className="d-flex align-items-center">
              <div className="fs-5 px-2 pb-1 py-0">+</div> ADD
            </div>
          </Button> */}
        </div>
        <div className="AdminSubscriptionTableSection bg-white p-2 px-0 rounded-4">
          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <ColorRing
                type="ThreeDots"
                color="#00BFFF"
                height={80}
                width={80}
              />
            </div>
          ) : (
           <div className='table-responsive'>

<table className="table">
              <thead>
                <tr>
                  <th className="customTh" scope="col">
                    S.no
                  </th>
                  <th className="customTh" scope="col">
                    Title
                  </th>
                  <th className="customTh" scope="col">
                    Description
                  </th>
                  <th className="customTh" scope="col">
                    Image
                  </th>
                  <th className="customTh" scope="col">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentPlans.map((plan, index) => (
                  <tr className="align-baseline" key={index}>
                    {/* <td className="customTd">{plan.id}</td> */}
                    <td className="customTd">{plan.index}</td>
                    <td className="customTd">{plan.title}</td>
                    <td className="customTd">{plan.description}</td>
                    <td className="customTd">
                      <img
                        className="p-2 rounded"
                        src={plan.image_url}
                        alt={plan.title}
                        height={50}
                        width={50}
                        style={{ backgroundColor: "#07bc0c" }}
                      />
                    </td>
                    <td className="customTd">
                      <div className="d-flex align-items-center">
                        <div
                          className="mx-2 mt-1 cursor-pointer"
                          onClick={() => handleEditClick(plan)}
                        >
                          <i className="fa fa-edit editColor" />
                        </div>
                        <div
                          className="mx-1 cursor-pointer"
                          onClick={() => handleDeleteClick(plan?.id)}
                        >
                          <i className="fa fa-trash trashColor" />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
</div>
          )}
          <div className="px-4 d-flex py-2 align-items-center justify-content-between flexColumn my3">
            {/* <div className="d-flex pageCountColor my3 ">
              Showing
              <span className="ps-1 pageCountColor">1-10 of 78</span>
            </div> */}
            {/* Pagination */}
            {/* <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <i
                      className="fa fa-angle-left text-black"
                      aria-hidden="true"
                    ></i>
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, index) => (
                  <li
                    key={index}
                    className={`page-item ${
                      currentPage === index + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <i
                      className="fa fa-angle-right text-black"
                      aria-hidden="true"
                    ></i>
                  </button>
                </li>
              </ul>
            </nav> */}
          </div>
        </div>
      </div>
      {editModalOpen && (
        <EditModal
          plan={selectedPlan}
          onClose={handleClose}
          token={userToken}
          updatePlan={updatePlanList}
        />
      )}
    </section>
  );
}
